import React, { Component, Suspense } from "react";
import Layout from "./components/Layout/";
import {
  Route,
  Switch,
  BrowserRouter as Router,
} from "react-router-dom";

// Import Css
import "./assets/css/materialdesignicons.min.css";
import "./Apps.scss";

import Parse from 'parse/dist/parse.min.js';

// Import css
import "./pages/Home/css/demo.css";

import "./assets/css/colors/default.css";

// Include Routes
import routes from "./routes";

const PARSE_APPLICATION_ID = 'AN0WJl0jeGQ62OqRwJmLsSC4AH0NipOgiF7ymudP'; //prod
//const PARSE_APPLICATION_ID = 'QOxwTbkWZjwmai4NXhb3UQHOSR07W2H6615iLqFR'; //test
Parse.initialize(PARSE_APPLICATION_ID);
Parse.serverURL = 'https://parse.vinowineapp.com/parse';

function withLayout(WrappedComponent, hasDarkTopBar, startLightLogo) {
  // ...and returns another component...
  return class extends React.Component {
    render() {
      return (
        <Layout hasDarkTopBar={hasDarkTopBar} startLightLogo={startLightLogo}>
          <WrappedComponent></WrappedComponent>
        </Layout>
      );
    }
  };
}

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true, error: error };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to console with full details
    console.error('React Error Boundary caught an error:', error);
    console.error('Error Info:', errorInfo);
    console.error('Error Stack:', error.stack);
    console.error('Component Stack:', errorInfo.componentStack);
  }

  Loader = () => {
    return (
      <div id="preloader">
        <div id="status">
          <div className="spinner">
            <div className="double-bounce1"></div>
            <div className="double-bounce2"></div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    if (this.state.hasError) {
      // Fallback UI
      const error = this.state.error;
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h1>Something went wrong</h1>
          <p>Please refresh the page or contact support if the problem persists.</p>
          <details style={{ whiteSpace: 'pre-wrap', marginTop: '20px', textAlign: 'left', maxWidth: '800px', margin: '20px auto' }}>
            <summary style={{ cursor: 'pointer', fontWeight: 'bold' }}>Error Details (click to expand)</summary>
            <pre style={{ background: '#f5f5f5', padding: '10px', borderRadius: '4px', overflow: 'auto' }}>
              {error && error.toString()}
              {error && error.stack && `\n\nStack trace:\n${error.stack}`}
            </pre>
          </details>
        </div>
      );
    }

    return (
      <React.Fragment>
        <Router>
          <Suspense fallback={this.Loader()}>
            <Switch>
              {routes.map((route, idx) =>
                route.isWithoutLayout ? (
                  <Route
                    path={route.path}
                    exact={route.exact}
                    component={route.component}
                    key={idx}
                  />
                ) : (
                  <Route
                    path={route.path}
                    exact
                    component={withLayout(route.component, route.isTopbarDark, route.startLightLogo)}
                    key={idx}
                  />
                )
              )}
            </Switch>
          </Suspense>
        </Router>
      </React.Fragment>
    );
  }
}

export default App;
